import { Component, Input, Output, EventEmitter } from '@angular/core';
import { EllipsisMenuItem } from '@gainsystems/gains-ui-commons';

export interface PieChartData {
  percentage: number;
  label: string;
}

@Component({
  selector: 'pie-chart-kpi',
  standalone: false,
  templateUrl: './pie-chart-kpi.component.html',
  styleUrl: './pie-chart-kpi.component.scss'
})
export class PieChartKpiComponent {
  @Input() widgetTitle = '';
  @Input() currentValue: PieChartData = { percentage: 0, label: 'Current Service Level' };
  @Input() targetValue: PieChartData = { percentage: 0, label: 'Company Target Service Level' };
  @Input() widthClass = 'extra-chart-small';
  @Input() menuItems: EllipsisMenuItem[] = [];
  @Input() widgetId = '';
  @Input() layout: 'horizontal' | 'vertical' = 'vertical';
  @Output() changeEvent = new EventEmitter<string>();

  handleMenuAction(action: string): void {
    // Emit the action to the parent component
    this.changeEvent.emit(action);
  }
}
